import React, { useState } from 'react';
import { Gem, Map, ShoppingBag, Info, ArrowRightLeft } from 'lucide-react';
import { gbFmt } from './gbApi';
import { GbStatement } from './GbStatement';
import { GbExchange } from './GbExchange';

/* Carteira de diamantes: saldo, de onde vem, intercâmbio e o extrato de tudo que foi gasto nas fases e na lojinha. */
export const GbGems = ({ player, config, onChange }) => {
  const custo = Number(config?.nodes?.[0]?.cost || 0);
  const taxa = Number(config?.exchange?.coins_per_diamond || 0);
  const [tick, setTick] = useState(0);
  // depois de um intercâmbio, o extrato lá embaixo recarrega junto com o saldo
  const atualizar = async () => { await onChange?.(); setTick((t) => t + 1); };
  return (
    <div className="pb-10" data-testid="gb-gems">
      <div className="relative overflow-hidden rounded-3xl border border-cyan-800/50"
        style={{ backgroundImage: 'url(/gb/map_graveyard.jpg)', backgroundSize: 'cover', backgroundPosition: 'center 35%' }}>
        <div className="bg-[linear-gradient(100deg,rgba(6,16,24,.96)_10%,rgba(6,16,24,.8)_60%,rgba(6,16,24,.45)_100%)] px-4 py-5">
          <p className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.28em] text-cyan-400/80">
            <Gem className="h-3.5 w-3.5" />carteira de diamantes
          </p>
          <p className="mt-2 flex items-center gap-2 font-mono text-4xl font-black leading-none text-cyan-200"
            data-testid="gb-gems-balance">
            <Gem className="h-7 w-7 text-cyan-300" />{gbFmt(player?.diamonds)}
          </p>
          <p className="mt-2 max-w-md text-[11px] leading-snug text-cyan-100/70">
            Os diamantes entram na sua conta quando você recarrega moedas no site e servem para
            entrar nas fases e comprar itens na lojinha.
            {taxa > 0 ? ` No intercâmbio, 1 diamante vira ${gbFmt(taxa)} moedas amarelas.` : ' Eles não viram moedas amarelas.'}
          </p>
        </div>
      </div>

      <GbExchange saldo={Number(player?.diamonds || 0)} taxa={taxa}
        maxOp={Number(config?.exchange?.max_per_op || 0)} onChange={atualizar} />

      <div className="mt-3 grid gap-2 sm:grid-cols-3">
        {[
          { Icon: Gem, t: 'como ganhar', d: 'recarregando moedas no site durante o evento', tone: 'cyan' },
          { Icon: Map, t: 'entrada das fases', d: custo ? `a partir de ${gbFmt(custo)} por fase` : 'cada fase tem seu custo', tone: 'amber' },
          taxa > 0
            ? { Icon: ArrowRightLeft, t: 'intercâmbio', d: `1 diamante = ${gbFmt(taxa)} moedas amarelas`, tone: 'cyan' }
            : { Icon: ShoppingBag, t: 'lojinha', d: 'itens de batalha, até 3 de cada', tone: 'purple' },
        ].map(({ Icon, t, d }) => (
          <div key={t} className="flex items-start gap-2.5 rounded-2xl border border-purple-800/60 bg-[#0e071a]/85 px-3 py-2.5">
            <Icon className="mt-[1px] h-4 w-4 flex-none text-cyan-300" />
            <div className="min-w-0">
              <p className="text-[11px] font-black uppercase tracking-wide text-cyan-100">{t}</p>
              <p className="text-[10px] leading-snug text-purple-200/65">{d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-center gap-2 rounded-2xl border border-cyan-900/50 bg-cyan-950/20 px-3 py-2">
        <Info className="h-3.5 w-3.5 flex-none text-cyan-300" />
        <p className="text-[11px] text-cyan-100/80">
          Histórico completo dos diamantes: tudo que entrou e tudo que saiu no evento.
        </p>
      </div>

      <div className="mt-3">
        <GbStatement key={tick} scope="diamonds" title="EXTRATO DOS DIAMANTES" testid="gb-gems-stmt" />
      </div>
    </div>
  );
};
